<template>
  <!-- # 5.3.1	债券基本条款 -->
  <el-container class="main_container w100">
    <el-main :class="{'ismobilePhone':isMobilePhone}">
      <div class="DataModule full_height">
        <!-- <el-row class="export-row" type="flex" justify="end">
          <span class="icon"></span>
          <span class="text" @click="exportExcel">导出Excel</span>
        </el-row> -->
        <el-row style="overflow-y: auto; height:100%;">
          <!-- Revised on 2022-03-05  -->
          <table id="table">
            <!-- Revised on 2022-03-05  -->
            <tr
              v-for="(value,key,index) in table_data"
              v-bind:key="index"
            >
              <td class="w20">{{row_keys[key]}}</td>
              <td class="w80">{{value}}</td>
            </tr>
          </table>
        </el-row>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { get_base_info, get_querykey } from 'common/js/http/v3Api'
import { exportTableData } from 'common/js/utils/utils'

export default {
  name: "baseInfo",
  data() {
    return {
      row_keys: {
        // "a0"  :	"债券代码",
        // "a1"	:	"债券简称",
        // "a2"	:	"交易市场"	,
        // "a3"	:	"上市日期",
        // "a4"	:	"摘牌日期",
        // "a5"	:	"最新债项评级",
        // "a5_1":	"最新评级(主体/债项)",
        // "a5_2":	"发行时评级(主体/债项)",
        // "a6"  :	"票面利率(当期)",
        // "a7"  :	"利率类型",
        // "a8"  :	"付息频率",
        // "a9"  :	"利率说明",
        // "b0"  :	"发行期限(年)",
        // "b1"  :	"剩余期限(年)",
        // "b2"  :	"剩余天数",
        // "b3"  :	"内含特殊条款",
        // "b4"  :	"条款说明",
        // "b5"	:	"发行人",
        // "b6"	:	"发行方式",
        // "b7"	:	"主承销商",
        // "b8"	:	"质押券代码",
        // "b9"	:	"债券全称",
        // "c0"	:	"债券类型",
        // "c1"	:	"起息日期",
        // "c2"	:	"到期日期",
        // "c3"	:	"实际到期日",
        // "c4"	:	"评级机构",
        // "c5"	:	"初始面值(元)/最新面值(元)",
        // "c5_2": "发行价格(元)/参考收益率(%)",
        // "c6"	:	"计息方式",
        // "c7"	:	"下一付息日",
        // "c8"	:	"距下一付息日(天)",
        // "c9"	:	"发行总量(亿元)",
        // "d0"	:	"当前余额(亿元)"	,
        // "d1"	:	"下一行权日",
        // "d2"	:	"是否城投债曲线样本券",
        // "d3"	:	"担保人",
        // "d4"	:	"担保方式",
        // "d5"	:	"担保时段",
        // "d6"	:	"折合标准券(元)",
        // "d7"	:	"招标标的"
        "a0": "Bond code",
        "a1": "Bond name abbreviation",
        "a2": "Trading market",
        "a3": "Listing date",
        "a4": "Delisting date",
        "a5": "Latest debt rating",
        "a5_1": "Latest rating (subject / debt)",
        "a5_2": "Rating at issue (subject / debt)",
        "a6": "Coupon Rate (current period; %)",
        "a7": "Interest rate type",
        "a8": "Interest payment frequency",
        "a9": "Interest rate description",
        "b0": "Term  (year)",
        "b1": "Term to maturity  (year)",
        "b2": "Days Remaining ",
        "b3": "Special terms included",
        "b4": "Clause description",
        "b5": "issuer",
        "b6": "Distribution method",
        "b7": "Lead underwriter",
        "b8": "Code of pledged bonds",
        "b9": "Full name of bond",
        "c0": "Bond type",
        "c1": "Value date",
        "c2": "Due date",
        "c3": "Actual maturity date",
        "c4": "Rating agencies",
        "c5": "Initial face value (yuan) / latest face value (yuan)",
        "c5_2": "Issuing price (yuan) / reference yield (%)",
        "c6": "Interest method",
        "c7": "Next interest payment date",
        "c8": "From next interest payment date (days)",
        "c9": "Total issued amount (100 million yuan)",
        "d0": "Current balance (100 million yuan)",
        "d1": "Next exercise date",
        "d2": "Sample bond of urban investment bond curve",
        "d3": "guarantee",
        "d4": "Guarantee method",
        "d5": "Guarantee period",
        "d6": "Converted into standard coupon (yuan)",
        "d7": "Subject of tender"
      },
      isMobilePhone: false,
      stockCode: '120303.SH',
      table_data: {}
    };
  },

  created() {
    this.isMobile()
  },
  mounted() {
    if (this.$route.query.stockCode) {
      this.stockCode = this.$route.query.stockCode
    }
    this.get_base_info()
  },
  methods: {
    /* Revised on 2022-03-05 */
    exportTableData() {
       let html = document
        .querySelector('table')
        .outerHTML.replace(/<(\w+) (.+?)>/g, (m, p1) => `<${p1}>`)
        .replace('<table>', '<table border>')
      // vnd.ms-excel.numberformat:@; 格式化文本
      // xmlns 和 head 中 用于显示网格线
      html = `<html xmlns:x="urn:schemas-microsoft-com:office:excel">
            <head>
              <xml>
                <x:ExcelWorkbook>
                  <x:ExcelWorksheets>
                    <x:ExcelWorksheet>
                      <x:WorksheetOptions>
                        <x:Print><x:ValidPrinterInfo /></x:Print>
                      </x:WorksheetOptions>
                    </x:ExcelWorksheet>
                  </x:ExcelWorksheets>
                </x:ExcelWorkbook>
              </xml>
            </head>
            <style>
              table{vnd.ms-excel.numberformat:@;}
            </style>
              ${html}
            </html>`
      let blob = new Blob([html], { type: 'application/octet-stream' })
      let url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.download = 'baseInfo.xlsx' // 重命名文件
      link.click()
      window.URL.revokeObjectURL(url) // 释放内存 
      /*import('@/vendor/Export2Excel').then(excel => {
        const tHeader = ['key', 'value']
        const filterVal = ['key', 'value']
        const table_data = this.table_data
        const jsonData = []
        for (let key in table_data) {
          // jsonData.push({ 'key': this.row_keys[key], 'value': table_data[key] })
          jsonData.push([this.row_keys[key], table_data[key]])
        }
        const data = this.formatJson(filterVal, jsonData)
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: this.filename,
          autoWidth: this.autoWidth,
          bookType: this.bookType
        })
      })*/
    },
    async searchTableData(item) {
      if (item) {
        this.stockCode = item;
        this.get_base_info()
      }
    },
    /* Revised on 2022-03-05 */
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]))
    },
    isMobile() {
      this.isMobilePhone = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      //isMobilePhone 代表设备信息 转换bool
      // this.setMobileStatus(!!this.isMobilePhone)
    },
    async get_base_info() {
      const { data } = await get_base_info({
        trd_code: this.stockCode,
      });
      const rows = data.result.data.rows[0];
      this.table_data = rows
    },
    // ...mapMutations(["setMobileStatus", "changeIndexShow"])
  }
};
</script>

<style scoped>
.ismobilePhone {
  padding: 0 !important;
  background: #fff !important;
}
.bgw {
  background: #fff;
}
.w100 {
  width: 100%;
}
.el-main {
  padding: 0;
  height: 100%;
}

table {
  height: calc(100% - 30px);
  width: 100%;
  padding: 10px 0;
}
tr:nth-of-type(odd) {
  background-color: #f2f2f2;
}
tr:nth-of-type(even) {
  background-color: #ffffff;
}
td {
  text-indent: 10px;
  word-wrap: break-word !important;
  overflow: visible !important;
  white-space: normal !important;
  text-overflow: ellipsis;
  border: 0;
  border-right: 1px solid #cacaca;
  height: 32px;
}
.w20 {
  width: 25%;
}
.w80 {
  width: 75%;
}
</style>
